"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _CordovaFileHelper = _interopRequireWildcard(require("./CordovaFileHelper"));

var _ErrorHelper = require("./ErrorHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("./DeviceInfoHelper"));

var DownloadHelper = /*#__PURE__*/function () {
  function DownloadHelper() {
    (0, _classCallCheck2["default"])(this, DownloadHelper);
  }

  (0, _createClass2["default"])(DownloadHelper, null, [{
    key: "getRedirectedUrl",

    /**
     * Follows one redirect of the given url and returns that url. If there is no redirect the proper url will be returned nevertheless
     * @param startUrl
     */
    value: function () {
      var _getRedirectedUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(startUrl) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (startUrl) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", null);

              case 2:
                return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
                  var httpRequest = new window.XMLHttpRequest();
                  httpRequest.open('HEAD', startUrl);

                  httpRequest.onreadystatechange = function () {
                    if (httpRequest.responseURL) {
                      console.log('redirection url from ' + startUrl + ' is ' + httpRequest.responseURL);
                      resolve(httpRequest.responseURL);
                    } else {//reject(new Error(`Could not get redirect url for ${startUrl}.`))
                    }
                  };

                  httpRequest.send();
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getRedirectedUrl(_x) {
        return _getRedirectedUrl.apply(this, arguments);
      }

      return getRedirectedUrl;
    }()
  }, {
    key: "getDataStorePath",
    value: function getDataStorePath(localFilename) {
      return "".concat(_DataStore.DATA_STORE_PATHS.DOWNLOADED_FILES, ".").concat(localFilename.replace(/\./g, '_'));
    }
    /**
     * Keeps the current file version if it is younger than maxAge
     * @param remoteSrc
     * @param localFilename
     * @param maxAge If falsy like 0 and null, it means keep forever. If < 0 it means force download. Stated in ms
     * @returns {Promise.<String>}
     */

  }, {
    key: "download",
    value: function () {
      var _download = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(remoteSrc, localFilename) {
        var maxAge,
            ignoreMaxAgeIfOffline,
            onError,
            filenameOnDisk,
            downloadFolder,
            downloadFilename,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                maxAge = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : null;
                ignoreMaxAgeIfOffline = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : true;

                onError = function onError(error) {
                  console.error("error downloading file from ".concat(remoteSrc, " to ").concat(localFilename, " with maxAge ").concat(maxAge), error);
                  (0, _ErrorHelper.addAdditionalDataToError)(error, {
                    method: 'download',
                    remoteSrc: remoteSrc,
                    localFilename: localFilename
                  });
                  return _promise["default"].reject(error);
                };

                _context2.prev = 3;
                _context2.next = 6;
                return this.getLocalFilename(localFilename, maxAge || null, ignoreMaxAgeIfOffline);

              case 6:
                filenameOnDisk = _context2.sent;

                if (!filenameOnDisk) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", filenameOnDisk);

              case 9:
                _context2.prev = 9;
                _context2.next = 12;
                return _CordovaFileHelper["default"].getDownloadFolder();

              case 12:
                downloadFolder = _context2.sent;
                downloadFilename = "".concat(localFilename, ".tmp");
                _context2.next = 16;
                return _CordovaFileHelper["default"].deleteFile(downloadFilename, downloadFolder);

              case 16:
                _context2.next = 18;
                return _CordovaFileHelper["default"].downloadFile(remoteSrc, downloadFolder, downloadFilename);

              case 18:
                _context2.next = 20;
                return _CordovaFileHelper["default"].moveFile("".concat(_CordovaFileHelper.LOCAL_FILENAMES.DOWNLOAD_FOLDER, "/").concat(downloadFilename), "".concat(_CordovaFileHelper.LOCAL_FILENAMES.DOWNLOAD_FOLDER, "/").concat(localFilename));

              case 20:
                _DataStore["default"].setSingleData(this.getDataStorePath(localFilename), {
                  remoteSrc: remoteSrc,
                  createTime: new Date().getTime()
                });

                return _context2.abrupt("return", _CordovaFileHelper["default"].getFileURL(localFilename, _CordovaFileHelper.LOCAL_FILENAMES.DOWNLOAD_FOLDER));

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](9);

                if (!filenameOnDisk) {
                  _context2.next = 28;
                  break;
                }

                return _context2.abrupt("return", filenameOnDisk);

              case 28:
                onError(_context2.t0);

              case 29:
                _context2.next = 34;
                break;

              case 31:
                _context2.prev = 31;
                _context2.t1 = _context2["catch"](3);
                onError(_context2.t1);

              case 34:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 31], [9, 24]]);
      }));

      function download(_x2, _x3) {
        return _download.apply(this, arguments);
      }

      return download;
    }()
    /**
     * Returns the local filename if that files is available, null otherwise.
     *
     * If maxAge is falsy (like 0 and null) it means forever
     */

  }, {
    key: "getLocalFilename",
    value: function () {
      var _getLocalFilename = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(localFilename) {
        var maxAge,
            ignoreMaxAgeIfOffline,
            fileEntry,
            dataStorePath,
            metadata,
            expired,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                maxAge = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : null;
                ignoreMaxAgeIfOffline = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : true;
                _context3.prev = 2;
                _context3.next = 5;
                return _CordovaFileHelper["default"].getFileEntry(localFilename, _CordovaFileHelper.LOCAL_FILENAMES.DOWNLOAD_FOLDER);

              case 5:
                fileEntry = _context3.sent;
                _context3.next = 10;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](2);

              case 10:
                if (fileEntry) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt("return", null);

              case 12:
                if (!(!maxAge || ignoreMaxAgeIfOffline && !_DeviceInfoHelper["default"].isOnline())) {
                  _context3.next = 14;
                  break;
                }

                return _context3.abrupt("return", _CordovaFileHelper["default"].getFileURL(localFilename, _CordovaFileHelper.LOCAL_FILENAMES.DOWNLOAD_FOLDER));

              case 14:
                // check if file age is too old
                dataStorePath = this.getDataStorePath(localFilename);
                _context3.next = 17;
                return _DataStore["default"].getElementByPath(dataStorePath);

              case 17:
                metadata = _context3.sent;
                expired = !metadata || !metadata.createTime || new Date().getTime() - metadata.createTime > maxAge;
                return _context3.abrupt("return", expired ? null : _CordovaFileHelper["default"].getFileURL(localFilename, _CordovaFileHelper.LOCAL_FILENAMES.DOWNLOAD_FOLDER));

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 8]]);
      }));

      function getLocalFilename(_x4) {
        return _getLocalFilename.apply(this, arguments);
      }

      return getLocalFilename;
    }()
  }]);
  return DownloadHelper;
}();

var _default = DownloadHelper;
exports["default"] = _default;